import { render, staticRenderFns } from "./MenuRequestsReviewer.vue?vue&type=template&id=5c0de7b6&scoped=true&"
import script from "./MenuRequestsReviewer.vue?vue&type=script&lang=js&"
export * from "./MenuRequestsReviewer.vue?vue&type=script&lang=js&"
import style0 from "./MenuRequestsReviewer.vue?vue&type=style&index=0&id=5c0de7b6&prod&lang=css&"
import style1 from "./MenuRequestsReviewer.vue?vue&type=style&index=1&id=5c0de7b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0de7b6",
  null
  
)

export default component.exports